module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAaCAYAAABsONZfAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgUlEQVQ4jZ3USw7AIAgE0KkXrSs8Ezs9qd00pv5wKAkBFi+zAyKSa63wdABwp5QyHBXe6YLhs9MwDDcFR0TBFTrCHTKhhbbwhJaQQRNkUQcvEakOCADFk9TKi4qqRg8qqho9SQ2wqAMMmsAJLYGFtmCHTLBCRzAiCnwRDQAAf57lAz3khV4SajRrAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_list_arrow.png
// module id = xWVU
// module chunks = 1